import React, { useRef } from "react";
import { useEffect, useState, useContext } from "react";
import { useDispatch, useSelector } from "react-redux";
import divisionActions from "../../../_actions/_qmsActions/divisionActions";
import issueActions from "../../../_actions/_qmsActions/cmtIssueActions";
import qmsTeamActions from "../../../_actions/_qmsActions/qmsTeamActions";
import TitleBar from "../../_common/TitleBar";
import { QmsDataExpandedDetailContext, QmsDataTable } from "../_common/QmsDataTable";
import "./qmsAdmin.css";
import QmsAdminModal_EditTeam from "./QmsAdminModal_EditTeam";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";

export default function QmsAdminTeams(props) {
  const { divisionId, tabId } = props;

  const dispatch = useDispatch();
  useEffect(() => dispatch(qmsTeamActions.getAll(divisionId)), [divisionId]);

  const qmsTeams = useSelector((state) => state.qms.qmsTeams[divisionId] || null);

  const columns = useRef([
    {
      id: "name",
      numeric: false,
      disablePadding: true,
      label: "Team Name",
    },
    {
      id: "description",
      numeric: false,
      disablePadding: false,
      label: "Description",
    },
    {
      id: "chairQmsUserId",
      numeric: false,
      disablePadding: false,
      label: "Chair/Vice Chair",
      render: (rowData) => `${rowData.chairQmsUserId}/${rowData.viceChairQmsUserId}`,
    },
    {
      id: "memberCount",
      numeric: false,
      disablePadding: false,
      label: "Members",
    },
  ]);

  return (
    <>
      <h3 className="text-muted">Teams/User Groups</h3>
      <QmsDataTable
        data={qmsTeams}
        columns={columns.current}
        idName="qmsTeamId"
        editModalComponent={
          <QmsAdminModal_EditTeam tabId={tabId} divisionId={divisionId} />
        }
        isExpandable={true}
        onDelete={(ids) => dispatch(qmsTeamActions.removeRange(ids, divisionId))}
        expandedDetailComponent={<QmsAdminTeams_ExpandedDetails />}
      />
    </>
  );
}

function QmsAdminTeams_ExpandedDetails(props) {
  const {} = props;

  const dispatch = useDispatch();

  const context = useContext(QmsDataExpandedDetailContext);
  useEffect(
    () =>
      context.data.qmsTeamId &&
      dispatch(qmsTeamActions.getMembers(context.data.qmsTeamId)),
    []
  );

  const qmsTeamMembers = useSelector((state) =>
    context.data.qmsTeamId
      ? state.qms.qmsTeamMembers[context.data.qmsTeamId] || null
      : null
  );

  const qmsTeamMemberRoles = useSelector((state) => state.qms.qmsTeamMemberRoles || null);

  return (
    <div>
      <h4>{context.data.name}</h4>
      <h5>{context.data.description}</h5>

      <div className="card bg-lightgray">
        <div className="card-body p-2">
          <span className="font-weight-bold">Members</span>
          <TableContainer className="bg-white">
            <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
              <TableHead>
                <TableRow>
                  <TableCell>
                    <b>Name (Emp. No)</b>
                  </TableCell>
                  <TableCell align="right">
                    <b>Unit</b>
                  </TableCell>
                  <TableCell align="right">
                    <b>Role</b>
                  </TableCell>
                  <TableCell align="right">
                    <b>Joined On</b>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {(qmsTeamMembers || []).map((qtm, index) => (
                  <TableRow
                    key={`expanded-qt-details-members_${index}`}
                    sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                  >
                    <TableCell component="th" scope="qtm">
                      {`${qtm.fullName} (${qtm.employeeNo})`}
                    </TableCell>
                    <TableCell align="right">{qtm.distUnit}</TableCell>
                    <TableCell align="right">
                      {
                        (qmsTeamMemberRoles || []).find(
                          (qtmr) => qtmr.value === qtm.memberRoleValue
                        ).displayName
                      }
                    </TableCell>
                    <TableCell align="right">
                      {new Date(qtm.joinedOn).toLocaleDateString()}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
      </div>
    </div>
  );
}
